import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'components/ui/input';
import { Button } from 'components/ui/button';

// CLEAR_BLOG

const Toolbar = ({ searchTerm, setSearchTerm }) => {
  const [searchBox, setSearchBox] = useState('')

  const onSubmit = (e) => {
    e.preventDefault()
    setSearchTerm(searchBox.trim())
  }

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-3 md:flex-row md:items-center md:gap-2">
      <div className="flex-1">
        <Input
          value={searchBox}
          onChange={(e) => setSearchBox(e.target.value)}
          placeholder="Search by name or question..."
          aria-label="Search survey standards"
        />
      </div>
      <div className="flex gap-2">
        <Button type="submit">Search</Button>
        {searchTerm && (
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              setSearchBox('')
              setSearchTerm('')
            }}
          >
            Clear
          </Button>
        )}
      </div>
    </form>
  );
};


Toolbar.propTypes = {
    className: PropTypes.string
};

export default Toolbar;
